import React from 'react';
import { Layout, FileText } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { useNavigate, useLocation } from 'react-router-dom';

interface FloatingNavProps {
  onToggleTabs: () => void;
  onToggleNotes: () => void;
  showTabs: boolean;
  showNotes: boolean;
}

const FloatingNav = ({ onToggleTabs, onToggleNotes, showTabs, showNotes }: FloatingNavProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isTabsPage = location.pathname === '/tabs';
  const isNotesPage = location.pathname === '/notes';

  const handleTabsClick = () => {
    if (isTabsPage) {
      onToggleTabs();
    } else {
      navigate('/tabs');
    }
  };

  const handleNotesClick = () => {
    if (isNotesPage) {
      onToggleNotes();
    } else {
      navigate('/notes');
    }
  };

  return (
    <div className={cn(
      "fixed bottom-4 left-1/2 -translate-x-1/2 z-50",
      "flex items-center gap-4 px-4 py-2 rounded-full",
      "bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60",
      "border shadow-lg"
    )}>
      <Button
        variant="ghost"
        size="sm"
        onClick={handleTabsClick}
        className={cn(
          "rounded-full flex items-center gap-2 transition-colors",
          (isTabsPage && showTabs) && "text-hintword-orange hover:text-hintword-orange/90",
          isTabsPage && "font-medium"
        )}
        title={isTabsPage ? "Toggle Tabs" : "Go to Tabs"}
      >
        <Layout className="h-4 w-4" />
        <span className="text-sm">Tabs</span>
      </Button>
      <Button
        variant="ghost"
        size="sm"
        onClick={handleNotesClick}
        className={cn(
          "rounded-full flex items-center gap-2 transition-colors",
          (isNotesPage && showNotes) && "text-hintword-orange hover:text-hintword-orange/90",
          isNotesPage && "font-medium"
        )}
        title={isNotesPage ? "Toggle Notes" : "Go to Notes"}
      >
        <FileText className="h-4 w-4" />
        <span className="text-sm">Notes</span>
      </Button>
    </div>
  );
};

export default FloatingNav; 